import FeatureItem from "../molecules/FeatureItem";

export type Feature = {
  id: string | number;
  iconSrc: string;
  title: string;
  text?: string;
};

export default function Stats({ features }: { features: Feature[] }) {
  if (!features?.length) return null;

  return (
    <section className="hidden md:flex justify-center items-center bg-muted py-10 px-5 3xl:py-20 3xl:px-10">
      <div className="lms-container">
        <div
        className="relative rounded-5xl p-6 md:p-20 overflow-hidden shadow-sm"
        style={{
          backgroundImage: "url('https://site-lms.fra1.digitaloceanspaces.com/bg_fram_30dd284c9e.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="rounded-2xl grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4">
          {features.map((f, idx) => {
            const isFirst = idx === 0;
            const isLast = idx === features.length - 1;
            return (
              <FeatureItem
                key={f.id}
                
                className={` rounded-none text-white bg-secondary transition-all 
                  duration-500 ease-in-out hover:bg-primaryGreen hover:scale-y-110 hover:-translate-y-5
                  ${isFirst ? "rounded-l-2xl" : isLast ? "rounded-r-2xl" : ""}
                  ${!isLast ? "border-gradient-y" : ""}`}
                iconSrc={f.iconSrc}
                title={f.title}
                text={f.text}
                titleClassName="text-3xl md:text-4xl"
              />
            );
          })}
        </div>
      </div>
      </div>
      
    </section>
  );
}
